export const normalizationTypes = [
    { label: 'None', value: '' },
    { label: 'Root with threshold', value: 'threshold-root' },
    { label: 'Log with threshold', value: 'threshold-log' },
    { label: 'Root', value: 'root' },
    { label: 'Log', value: 'log' },
    { label: 'Threshold', value: 'threshold' },
    { label: 'Relative', value: 'relative' }
];

export type NormalizationType = typeof normalizationTypes[number]['value'];

export const normalizeEmotions = (normalizationType:string, emotions: any) => {
    console.log("normalizing")
    let maxScore = Math.max(...emotions.flatMap((e:any) => Object.values(e.emotions).map((em:any) => em.score)));
    let threshold = 0.5;

    return emotions.map((emotion:any) => {
        let normalizedEmotions: any = {};

        Object.keys(emotion.emotions).forEach(emotionName => {
            let score = emotion.emotions[emotionName].score;
            let normalizedScore = score;

            switch (normalizationType) {
                case "relative":
                    normalizedScore = (score / maxScore) * 100;
                    break;
                case "threshold":
                    normalizedScore = score >= maxScore * threshold ? (score / maxScore) * 100 : 0;
                    break;
                case "log":
                    normalizedScore = (Math.log(score + 1) / Math.log(maxScore + 1)) * 100;
                    break;
                case "root":
                    normalizedScore = (Math.sqrt(score) / Math.sqrt(maxScore)) * 100;
                    break;
                case "threshold-log":
                    normalizedScore = score >= maxScore * threshold ? (Math.log(score + 1) / Math.log(maxScore + 1)) * 100 : 0;
                    break;
                case "threshold-root":
                    normalizedScore = score >= maxScore * threshold ? (Math.sqrt(score) / Math.sqrt(maxScore)) * 100 : 0;
                    break;
                default:
                    normalizedScore = score;
            }

            normalizedEmotions[emotionName] = {
                ...emotion.emotions[emotionName],
                score: normalizedScore,
            };
        });

        return { ...emotion, emotions: normalizedEmotions };
    });
}